import { render, staticRenderFns } from "./platePay_view.vue?vue&type=template&id=f798c66a&scoped=true&"
import script from "./platePay_view.vue?vue&type=script&lang=js&"
export * from "./platePay_view.vue?vue&type=script&lang=js&"
import style0 from "./platePay_view.vue?vue&type=style&index=0&id=f798c66a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f798c66a",
  null
  
)

export default component.exports